import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "goodslist-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.location"),
      layout: "vertical"
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("form.placeSelectLocation")
    },
    model: {
      value: _vm.value.location,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "location", $$v);
      },
      expression: "value.location"
    }
  }, _vm._l(_vm.locationClient, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.goodsTitle")
    }
  }, [_c("Title", {
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.value.titles,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "titles", $$v);
      },
      expression: "value.titles"
    }
  }), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.titleColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.titleColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "titleColor", $$v);
      },
      expression: "value.titleColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.titleFontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "titleFontSize", $$v);
      },
      expression: "value.titleFontSize"
    }
  })], 1), _c("SubCard", {
    class: {
      "location-disabled": !_vm.value.location.includes(2)
    },
    attrs: {
      title: _vm.$t("form.mobile")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.titlePaddingTop"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.titlePaddingTop,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "titlePaddingTop", $$v);
      },
      expression: "value.titlePaddingTop"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.titlePadingBottom"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.titlePadingBottom,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "titlePadingBottom", $$v);
      },
      expression: "value.titlePadingBottom"
    }
  })], 1)], 1), _c("SubCard", {
    class: {
      "location-disabled": !_vm.value.location.includes(1)
    },
    attrs: {
      title: _vm.$t("form.PCMedia")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.titlePaddingTop"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcTitlePaddingTop,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcTitlePaddingTop", $$v);
      },
      expression: "value.pcTitlePaddingTop"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.titlePadingBottom"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcTitlePadingBottom,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcTitlePadingBottom", $$v);
      },
      expression: "value.pcTitlePadingBottom"
    }
  })], 1)], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.banner")
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("com.dragSort"),
      "show-icon": ""
    }
  })], 1), _c("ImgList", {
    model: {
      value: _vm.value.pathlink,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pathlink", $$v);
      },
      expression: "value.pathlink"
    }
  })], 1), _c("SubCard", {
    class: {
      "location-disabled": !_vm.value.location.includes(1)
    },
    attrs: {
      title: _vm.$t("form.PCMedia")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.oneLineNum"),
      layout: "vertical"
    }
  }, [_c("InputNumber", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 1,
      max: 6
    },
    model: {
      value: _vm.value.pcBannerSizeNum,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBannerSizeNum", $$v);
      },
      expression: "value.pcBannerSizeNum"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcBannerSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBannerSpace", $$v);
      },
      expression: "value.pcBannerSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageVerticalSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcBannerVerticalSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBannerVerticalSpace", $$v);
      },
      expression: "value.pcBannerVerticalSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.BannerHeight"),
      layout: "vertical"
    }
  }, [_c("a-row", [_c("InputBarSelect", {
    attrs: {
      min: 100,
      max: 600,
      options: _vm.pcHeight
    },
    model: {
      value: _vm.value.pcBannerHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBannerHeight", $$v);
      },
      expression: "value.pcBannerHeight"
    }
  })], 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.marginSpace"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcHorizontalPadding,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcHorizontalPadding", $$v);
      },
      expression: "value.pcHorizontalPadding"
    }
  })], 1)], 1), _c("SubCard", {
    class: {
      "location-disabled": !_vm.value.location.includes(2)
    },
    attrs: {
      title: _vm.$t("form.mobile")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.oneLineNum"),
      layout: "vertical"
    }
  }, [_c("InputNumber", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 1,
      max: 6
    },
    model: {
      value: _vm.value.mBannerSizeNum,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mBannerSizeNum", $$v);
      },
      expression: "value.mBannerSizeNum"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.mBannerSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mBannerSpace", $$v);
      },
      expression: "value.mBannerSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageVerticalSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 50,
      suffix: "px"
    },
    model: {
      value: _vm.value.mBannerVerticalSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mBannerVerticalSpace", $$v);
      },
      expression: "value.mBannerVerticalSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.BannerHeight"),
      layout: "vertical"
    }
  }, [_c("a-row", [_c("InputBarSelect", {
    attrs: {
      min: 10,
      max: 400,
      options: _vm.mHeight
    },
    model: {
      value: _vm.value.mBannerHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mBannerHeight", $$v);
      },
      expression: "value.mBannerHeight"
    }
  })], 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.marginSpace"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.mHorizontalPadding,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mHorizontalPadding", $$v);
      },
      expression: "value.mHorizontalPadding"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };